import { api, config } from '../../../helpers/api';

export async function getMoodTrackerAverageRequest() {
  const response = await api.get('/mood_tracker/avg/', config('json'));
  return response.data;
}

export async function sendDeviceInfoRequest({
  device_id,
  is_mobile,
  os,
  user_agent,
  device_model
}) {
  return await api.post(
    '/device/',
    {
      device_id,
      is_mobile,
      os,
      user_agent,
      device_model
    },
    config('json')
  );
}
